/* Splide v4.1.4 (MIT), vendored in bumpino-splide-4.1.4.min.js. */
(() => {
  if (customElements.get('bumpino-baby-carousel')) return;
  class BumpinoBabyCarousel extends HTMLElement {
    connectedCallback() {
      // Theme-editor inserts can connect before child markup or deferred vendor code.
      this.init = this.init.bind(this);
      this.frame = requestAnimationFrame(this.init);
      document.addEventListener('shopify:section:load', this.init);
      window.addEventListener('load', this.init, { once: true });
    }
    init() {
      if (!this.isConnected || this.slider || !window.Splide) return;
      const root = this.querySelector('.splide');
      const slides = this.querySelectorAll('.bb2__card');
      if (!root || slides.length < 2) return;
      this.labels = JSON.parse(this.querySelector('[data-baby-labels]').textContent);
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.enabled = this.dataset.autoplay === 'true' && !this.motion.matches;
      this.inView = false;
      this.hovered = false;
      this.cleanup = [];
      const on = (target, event, fn, options) => {
        target.addEventListener(event, fn, options);
        this.cleanup.push(() => target.removeEventListener(event, fn, options));
      };
      this.slider = new window.Splide(root, {
        type: 'loop', fixedWidth: 'calc((100% - 72px) / 3.3)', gap: 20,
        perMove: 1, speed: 550, drag: true, flickPower: 350,
        direction: getComputedStyle(this).direction === 'rtl' ? 'rtl' : 'ltr',
        arrows: true, pagination: false, keyboard: 'focused',
        autoplay: 'pause', interval: Number(this.dataset.interval) || 6000,
        pauseOnHover: false, pauseOnFocus: false, resetProgress: true,
        reducedMotion: { speed: 0, rewindSpeed: 0, autoplay: 'pause' },
        i18n: { prev: this.labels.previous, next: this.labels.next,
          first: this.labels.next, last: this.labels.previous,
          carousel: this.labels.carousel, slide: this.labels.slide,
          select: this.labels.select, slideLabel: this.labels.slide_label },
        breakpoints: { 1024: { fixedWidth: '43%', gap: 18 }, 640: { fixedWidth: '82%', gap: 14 } }
      });
      this.slider.on('drag', () => this.stop());
      this.slider.mount();
      this.querySelectorAll('[data-baby-controls]').forEach(el => { el.hidden = false; });
      const track = this.querySelector('.splide__track');
      on(track, 'pointerdown', () => this.stop(), { passive: true });
      on(root, 'keydown', event => {
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) this.stop();
      });
      this.querySelectorAll('.splide__arrow').forEach(button => on(button, 'click', () => this.stop()));
      on(root, 'pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.syncPlayback(); }
      });
      on(root, 'pointerleave', () => { this.hovered = false; this.syncPlayback(); });
      // Keyboard interaction also stops autoplay for uninterrupted browsing.
      on(root, 'focusin', () => this.stop());
      on(document, 'visibilitychange', () => this.syncPlayback());
      on(this.motion, 'change', () => { if (this.motion.matches) this.stop(); });
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting;
        this.syncPlayback();
      }, { threshold: 0.15 });
      this.observer.observe(track);
      on(document, 'shopify:block:select', event => {
        const card = event.target.closest('.bb2__card');
        if (!card || !this.contains(card)) return;
        const index = Array.from(slides).findIndex(slide => slide.dataset.productId === card.dataset.productId);
        this.stop();
        if (index >= 0) this.slider.go(index);
      });
      this.syncPlayback();
    }
    stop() { this.enabled = false; this.syncPlayback(); }
    syncPlayback() {
      if (!this.slider) return;
      const active = this.enabled && this.inView && !document.hidden && !this.hovered;
      if (active) this.slider.Components.Autoplay.play();
      else this.slider.Components.Autoplay.pause();
      this.dataset.playback = active ? 'playing' : 'paused';
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      document.removeEventListener('shopify:section:load', this.init);
      window.removeEventListener('load', this.init);
      this.observer?.disconnect();
      this.cleanup?.forEach(remove => remove());
      this.slider?.destroy(true);
      this.slider = null;
    }
  }
  customElements.define('bumpino-baby-carousel', BumpinoBabyCarousel);
})();
